import { useEffect, useState } from 'react';
import {
  getOneLiveChatStatus,
  subscribeOneLiveChatStatus,
} from '@belong/integrations-belong-one-chat/utils';
import { useFeatureFlag } from 'src/features/feature-flags/hooks';

type SupportChatProvider = 'one' | 'intercom';

let latchedProvider: SupportChatProvider | null = null;

function latchProvider(provider: SupportChatProvider | null) {
  latchedProvider ??= provider;

  return latchedProvider;
}

export function useSupportChatProvider(): SupportChatProvider | null {
  const { isEnabled, isReady, hasTimedout } = useFeatureFlag(
    'belong-one-live-chat',
  );

  if (isReady || hasTimedout) {
    return latchProvider(isEnabled ? 'one' : null);
  }

  return latchedProvider;
}

export function useOneLiveChatStatus() {
  const [status, setStatus] = useState(getOneLiveChatStatus);

  useEffect(() => {
    setStatus(getOneLiveChatStatus());

    return subscribeOneLiveChatStatus(() => setStatus(getOneLiveChatStatus()));
  }, []);

  return status;
}
